<template>
  <div class="global-container container-fluid">
    <div class="row">
      <div class="col-lg-6 right-reg">
        <div class="card login-form">
          <div class="card-body">
            <div id="logo_home" class="logologin">
              <h1>
                <img src="../../../public/img/logo-pardis.png" width="85%" alt="City tours" data-retina="true"
                  @click.prevent="gotoHome" style="cursor: pointer" />
              </h1>
            </div>
            <div class="row">
              <h3 style="margin: 30px 20px !important; color: #635d5d; font-weight: 500;">
                 {{ $t("PasswordRecoveryRequest") }} 
              </h3>
            </div>

            <div class="sign-in-wrapper">
              <div class="group_mdi inputContainer">
                <input class="form-control-sm" type="text" v-model="email" />
                <span class="highlight"></span>
                <span class="bar"></span>
                <label>  {{ $t("Email") }} </label>

                <i class="icon_mail_alt"></i>

                <p class="text-danger" v-if="!$v.email.required && $v.email.$dirty">
                  {{ $t("PleaseEnterEmail") }} 
                </p>
                <p class="text-danger" v-if="!$v.email.email">
                    {{ $t("EmailNotValid") }} 
                </p>
              </div>
            </div>
            <div style="margin-bottom: 20px; text-align:center;">
              <router-link to="/login">   {{ $t("BackToLoginPage") }}  </router-link>
            </div>
            <div class="text-center">
              <button v-if="!isLoading" type="submit" @click.prevent="forgetPassword" class="btn_login"
                :disabled="$v.$invalid" :class="{ disabledBtn: $v.$invalid }">
                {{ $t("RecoverPassword") }} 
              </button>

              <button v-if="isLoading" type="submit" class="btn_login">
                بازیابی رمز عبور
                <loadingBar type="ring" class="loading-btn"></loadingBar>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-6 left-reg"></div>
    </div>
  </div>
</template>
<script>
import store from "../../store/index";
import loadingBar from "@/components/loading/pdkLoadingBar";
import { required, email, maxLength } from "vuelidate/lib/validators";

export default {
  store,
  components: { loadingBar },
  data() {
    return {
      email: "",
      isLoading: false,
    };
  },
  validations: {
    email: {
      required,
      email,
      maxLength: maxLength(100),
    },
  },
  methods: {
    async forgetPassword() {
      const data = {
        clientId: "ota-implicit-localhost",
        policy: 0,
        email: this.email,
        username: this.email,
      };

      this.isLoading = true;
      const res = await this.$store.dispatch("forgetPassword", data);

      if (res.status == 200) {
        if (res.data === "User Not Found") {
          // alert("کاربر با ایمیل وارد شده یافت نشد !!!");
          this.$toast.error("کاربر با ایمیل وارد شده یافت نشد !!!", {
            position: "top-center",
            timeout: 4500,
            closeOnClick: true,
            pauseOnFocusLoss: true,
            pauseOnHover: true,
            draggable: true,
            draggablePercent: 1.59,
            showCloseButtonOnHover: false,
            hideProgressBar: false,
            icon: true,
            rtl: true,
          });
          this.isLoading = false;
          return;
        }
        // alert("رمز عبور با موفقیت به ایمیل شما ارسال گردید.");
        this.$toast.success("رمز عبور با موفقیت به ایمیل شما ارسال گردید.", {
          position: "top-center",
          timeout: 4500,
          closeOnClick: true,
          pauseOnFocusLoss: true,
          pauseOnHover: true,
          draggable: true,
          draggablePercent: 1.59,
          showCloseButtonOnHover: false,
          hideProgressBar: false,
          icon: true,
          rtl: true,
        });

        this.isLoading = false;
        this.$router.push("/login");
      } else {
        // alert("ایمیل شما صحیح نمی باشد");
        this.$toast.error("ایمیل شما صحیح نمی باشد", {
          position: "top-center",
          timeout: 4500,
          closeOnClick: true,
          pauseOnFocusLoss: true,
          pauseOnHover: true,
          draggable: true,
          draggablePercent: 1.59,
          showCloseButtonOnHover: false,
          hideProgressBar: false,
          icon: true,
          rtl: true,
        });
      }
    },
  },
};
</script>
<style scoped>
.invalid {
  border: 1px solid red !important;
  box-shadow: 0 0 5px red !important;
}

.loading-btn {
  padding-right: 50px !important;
}

.small-dialog-header {
  font-size: 18px;
  width: calc(100%);
  right: 0px;
  top: 0;
  -webkit-border-radius: 4px 4px 0 0;
  -moz-border-radius: 4px 4px 0 0;
  border-radius: 4px 4px 0 0;
  display: inline-block;
  background-color: #fff;
  padding: 15px 20px;
  margin-bottom: 30px;
}

#logo_home h1 a,
header#colored #logo_home h1 a,
header#plain #logo_home h1 a,
header.sticky #logo_home h1 a {
  width: 160px;
  height: 34px;
  display: block;
  background-image: url(../../../public/img/pdk_logo.png);
  background-repeat: no-repeat;
  background-position: left top;
  background-size: 160px 34px;
  text-indent: -9999px;
  text-align: center;
  margin: 20px;
}

#logo_home img {
  max-width: 400px;
}
</style>

<style >
html,
body {
  height: 100%;
  background-color: #f5f7f9;
}

.global-container {
  height: 100vh !important;
  background-color: #f5f7f9;
  padding-top: 5%;
  background-image: url("../../../public/img/a89dausd90as90duajsdasd09 copy_c.jpg");
  background-size: cover;
}

.form-control {
  font-size: 13px;
  color: #333;
  height: 40px;
  border-radius: 3px;
  padding-right: 40px;
}

.login-top-title {
  text-align: center;
  margin: 30px 20px;
}

.login-top-title h3 {
  font-size: 16px;
  color: #2561a4;
}

.card-title {
  font-weight: 300;
}

.btn {
  font-size: 14px;
  margin-top: 20px;
}

.login-form {
  width: 100%;
}

.card-body {
  padding: 30px 15px 30px 15px;
  line-height: 1.6 !important;
  border-top: 0px solid;
}

.inputContainer i {
  font-size: 20px;
  color: #11bddbad;
  margin-bottom: 6px;
  margin-right: -8px;
}

.inputContainer {
  width: 100%;
  margin-bottom: 10px;
}
</style>